"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Method = void 0;
const url_1 = require("@rtbhouse-apps/commonlib/dist/url");
const lodash_1 = require("lodash");
var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
    Method["PATCH"] = "PATCH";
})(Method || (exports.Method = Method = {}));
class Api {
    constructor(config) {
        this.config = config;
    }
    buildUrl(endpoint, queryParams) {
        let apiHost;
        if (this.config.apiOnSameHost) {
            apiHost = "//" + window.location.host;
        }
        else if (this.config.apiHost) {
            apiHost = this.config.apiHost;
        }
        else {
            apiHost = "//api." + window.location.host;
        }
        const { apiDirectory = "api" } = this.config;
        if (!Array.isArray(endpoint)) {
            endpoint = [endpoint];
        }
        const path = endpoint.join("/");
        const fullPath = (0, lodash_1.compact)([(0, lodash_1.trimEnd)(apiHost), (0, lodash_1.trim)(apiDirectory, "/"), (0, lodash_1.trim)(path, "/")]).join("/");
        let queryString = (0, url_1.formatQueryString)(queryParams);
        if (queryString) {
            queryString = "?" + queryString;
        }
        return fullPath + queryString;
    }
    async request(method, endpoint, queryParams, headers, body, signal) {
        const url = this.buildUrl(endpoint, queryParams);
        // build query params
        const requestInit = {
            method,
            headers: Object.assign({ "X-Requested-With": "XMLHttpRequest" }, headers),
            body,
            mode: "cors",
            credentials: "include",
            cache: "no-cache",
            redirect: "follow",
            signal,
        };
        // fetch resolved whether it is successful or not
        const response = await fetch(url, requestInit);
        // so for failed response, throw response as error
        if (!response.ok) {
            throw response;
        }
        return response;
    }
}
exports.default = Api;
//# sourceMappingURL=api.js.map